import { QuestionItem } from "@/components/QuestionItem";
import ExternalLink from "@/assets/Icons/external-link.svg?react";
import {
  AmericaAvailableCountries,
  ComingCountries,
  EuropeAvailableCountries,
  OceaniaAvailableCountries,
} from "@/constants/Countries";
import { useTranslation } from "react-i18next";

export const BusinessFaqs = () => {
  const [tBusiness] = useTranslation("business");

  return (
    <div className="w-full flex flex-col justify-center items-center gap-6 max-w-screen-xl">
      <h1 className="text-center text-2xl lg:text-3xl 2xl:text-4xl text-white lg:max-w-[60%] mb-4">
        {tBusiness("FAQs.Title")}
      </h1>

      <QuestionItem
        color="white"
        question={tBusiness("FAQs.Question1.Question")}
        answer={tBusiness("FAQs.Question1.Answer")}
      />
      <QuestionItem
        color="white"
        question={tBusiness("FAQs.Question2.Question")}
        answer={tBusiness("FAQs.Question2.Answer")}
      />
      <QuestionItem
        color="white"
        question={tBusiness("FAQs.Question3.Question")}
      >
        <a
          href="https://s3.us-west-1.amazonaws.com/sendola.io/Black/Payment+Methods+V2.pdf"
          target="_black"
          rel="noopener noreferrer"
          className="flex items-center gap-1 underline underline-offset-4 font-light cursor-pointer"
        >
          {tBusiness("FAQs.Question3.Answer")}
          <ExternalLink className="w-5 h-5" />
        </a>
      </QuestionItem>
      <QuestionItem
        color="white"
        question={tBusiness("FAQs.Question4.Question")}
        answer={tBusiness("FAQs.Question4.Answer")}
      >
        <div className="grid grid-cols-2 sm:grid-cols-3">
          <ul className="row-span-3 sm:row-span-2 list-disc list-inside flex flex-col gap-1 mt-4 text-xs md:text-sm">
            <p className="font-semibold text-base">
              {tBusiness("FAQs.Question4.Europe.Name")}
            </p>

            {EuropeAvailableCountries.map((country, index) => (
              <li key={`country-${index}`}>
                {tBusiness(`Countries.${country}`)}
              </li>
            ))}
          </ul>

          <ul className="list-disc list-inside flex flex-col gap-1 mt-4 text-xs md:text-sm">
            <p className="font-semibold text-base">
              {tBusiness("FAQs.Question4.Americas.Name")}
            </p>
            {AmericaAvailableCountries.map((country, index) => (
              <li key={`country-${index}`}>
                {tBusiness(`Countries.${country}`)}
              </li>
            ))}
          </ul>

          <ul className="list-disc list-inside flex flex-col gap-1 mt-4 text-xs md:text-sm">
            <p className="font-semibold text-base">
              {tBusiness("FAQs.Question4.Oceania.Name")}
            </p>
            {OceaniaAvailableCountries.map((country, index) => (
              <li key={`country-${index}`}>
                {tBusiness(`Countries.${country}`)}
              </li>
            ))}
          </ul>

          <ul className="list-disc list-inside flex flex-col gap-1 mt-4 text-xs md:text-sm">
            <p className="font-semibold text-base">
              {tBusiness("FAQs.Question4.Upcoming.Name")}
            </p>
            {ComingCountries.map((country, index) => (
              <li key={`country-${index}`}>
                {tBusiness(`Countries.${country}`)}
              </li>
            ))}
            <div className="h-2 w-full" />
          </ul>
        </div>
      </QuestionItem>
      <QuestionItem
        color="white"
        question={tBusiness("FAQs.Question5.Question")}
        answer={tBusiness("FAQs.Question5.Answer")}
      />
      <QuestionItem
        color="white"
        question={tBusiness("FAQs.Question6.Question")}
        answer={tBusiness("FAQs.Question6.Answer")}
      />
    </div>
  );
};
